var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.0684C21.8765 13.0803 21.7507 13.0875 21.6272 13.0875C20.2594 13.0875 18.9836 12.4063 18.2331 11.2758V17.4422C18.2331 19.9589 16.1657 22 13.6166 22C11.0674 22 9 19.9589 9 17.4422C9 14.9254 11.0674 12.8843 13.6166 12.8843C13.7134 12.8843 13.8078 12.8939 13.9022 12.8987V15.1453C13.8078 15.1334 13.7134 15.1166 13.6166 15.1166C12.3166 15.1166 11.2611 16.1587 11.2611 17.4422C11.2611 18.7256 12.3166 19.7677 13.6166 19.7677C14.9166 19.7677 16.0665 18.7543 16.0665 17.4708L16.0883 7H18.2646C18.4704 8.92639 20.0439 10.4321 22 10.5731V13.0684Z",
    fill: "#D19B16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.b2f2e49925412491a154a7d02eb06faf.svg";
export { ForwardRef as ReactComponent };